// This file now uses the v8 compat syntax, assuming Firebase is loaded globally from the CDN.

// Tell TypeScript that a global 'firebase' object exists, provided by the scripts in index.html
declare const firebase: any;

// Your web app's Firebase configuration
// NOTA: Firebase API keys en web son públicas por diseño.
// La seguridad se implementa mediante Firebase Security Rules.
// Usamos variables de entorno por consistencia con las cursor rules.
const firebaseConfig = {
  apiKey: (window as any).FIREBASE_API_KEY,
  // En localhost usar dominio estándar, en producción usar dominio personalizado
  authDomain: window.location.hostname === 'localhost' 
    ? "appmor-25e91.firebaseapp.com" 
    : "appmor.app",
  projectId: "appmor-25e91",
  storageBucket: "appmor-25e91.firebasestorage.app",
  messagingSenderId: "153994217551",
  appId: "1:153994217551:web:0730d5c5d99cc4bf81823a",
};

// Initialize Firebase only if it hasn't been initialized yet
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Get a reference to the services using the v8 compat syntax
export const auth = firebase.auth();
export const db = firebase.firestore();
// IMPORTANTE: La Cloud Function processAIChatMessage está desplegada en europe-west1
// En v8 compat, hay que usar firebase.app().functions(region)
export const functions = firebase.app().functions('europe-west1');
export const storage = firebase.storage();
export const FieldValue = firebase.firestore.FieldValue;
export const FieldPath = firebase.firestore.FieldPath;

// ============================================
// EMULADORES PARA DESARROLLO LOCAL
// ============================================
// Activa con: VITE_USE_EMULATORS=true en .env.local
// O ejecuta: pnpm run dev:emulators
const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';

if (useEmulators && window.location.hostname === 'localhost') {
  // Using Firebase emulators (local development)
  auth.useEmulator('http://localhost:9099');
  db.useEmulator('localhost', 8080);
  functions.useEmulator('localhost', 5001);
  storage.useEmulator('localhost', 9199);
}

// Firebase configurado
// Para desarrollo con emuladores: VITE_USE_EMULATORS=true
// Para desarrollo con producción: añadir localhost a dominios autorizados en Firebase Console